// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as GeoRegionHook from "../../../../library/data-source/geo-region/repo/GeoRegionHook.bs.js";
import * as CountryContext from "../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Column$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as PorterStoreIcons from "./components/PorterStoreIcons.bs.js";
import * as PorterStoreToast from "./components/PorterStoreToast.bs.js";
import * as PorterStoreTypes from "./PorterStoreTypes.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as PorterStoreStrings from "./PorterStoreStrings.bs.js";
import * as PorterStoreToastHook from "./components/PorterStoreToastHook.bs.js";
import * as PorterStoreOrdersTable from "./components/PorterStoreOrdersTable.bs.js";
import * as PorterStoreOrderSidebar from "./components/PorterStoreOrderSidebar.bs.js";
import * as PorterStoreOrderRepoManager from "../app/repo/PorterStoreOrderRepoManager.bs.js";
import * as PorterStoreProductRepoManager from "../app/repo/PorterStoreProductRepoManager.bs.js";

function PorterStoreComponent(Props) {
  var match = CountryContext.useContext(undefined);
  var geoRegions = GeoRegionHook.useGeoRegions(match.country);
  var match$1 = React.useState(function () {
        return /* InProgress */0;
      });
  var setActiveTab = match$1[1];
  var activeTab = match$1[0];
  var match$2 = React.useState(function () {
        
      });
  var setSelectedOrder = match$2[1];
  React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  PorterStoreProductRepoManager.getRepo(undefined);
  var match$3 = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var setPendingOrders = match$3[1];
  var pendingOrders = match$3[0];
  var match$4 = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var setCompletedOrders = match$4[1];
  var completedOrders = match$4[0];
  var match$5 = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var setOrderDetail = match$5[1];
  var orderDetail = match$5[0];
  var match$6 = React.useState(function () {
        return false;
      });
  var setIsLoadingMore = match$6[1];
  var isLoadingMore = match$6[0];
  var OrderRepoInstance = PorterStoreOrderRepoManager.getRepo(undefined);
  var match$7 = React.useState(function () {
        return "";
      });
  var setSearchMobile = match$7[1];
  var searchMobile = match$7[0];
  var match$8 = PorterStoreToastHook.useToast(3000, undefined);
  var showSuccess = match$8[1];
  var toastState = match$8[0];
  var pendingPagination = React.useRef({
        offset: 0,
        scrollCount: 0,
        hasMore: true
      });
  var completedPagination = React.useRef({
        offset: 0,
        scrollCount: 0,
        hasMore: true
      });
  var getOrdersState = function (tab) {
    if (tab) {
      return [
              completedOrders,
              setCompletedOrders
            ];
    } else {
      return [
              pendingOrders,
              setPendingOrders
            ];
    }
  };
  var match$9 = getOrdersState(activeTab);
  var setOrders = match$9[1];
  var orders = match$9[0];
  var fetchOrdersForTab = function (tab, status, setData, offsetOpt, appendOpt, mobileOpt, param) {
    var offset = offsetOpt !== undefined ? offsetOpt : 0;
    var append = appendOpt !== undefined ? appendOpt : false;
    var mobile = mobileOpt !== undefined ? mobileOpt : "";
    var pag = tab ? completedPagination : pendingPagination;
    if (append) {
      Curry._1(setIsLoadingMore, (function (param) {
              return true;
            }));
    } else {
      Curry._1(setData, (function (param) {
              return {
                      TAG: /* Loading */0,
                      _0: undefined
                    };
            }));
      pag.current = {
        offset: 0,
        scrollCount: 0,
        hasMore: true
      };
    }
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._4(OrderRepoInstance.fetchOrders, status, offset, 20, mobile);
                }), (function (data) {
                  if (data.length < 20) {
                    pag.current = {
                      offset: pag.current.offset,
                      scrollCount: pag.current.scrollCount,
                      hasMore: false
                    };
                  }
                  if (append) {
                    Curry._1(setData, (function (prev) {
                            switch (prev.TAG | 0) {
                              case /* Live */1 :
                                  return {
                                          TAG: /* Live */1,
                                          _0: Belt_Array.concat(prev._0, data)
                                        };
                              case /* Loading */0 :
                              case /* Error */2 :
                                  return {
                                          TAG: /* Live */1,
                                          _0: data
                                        };
                              
                            }
                          }));
                    return Curry._1(setIsLoadingMore, (function (param) {
                                  return false;
                                }));
                  } else {
                    return Curry._1(setData, (function (param) {
                                  return {
                                          TAG: /* Live */1,
                                          _0: data
                                        };
                                }));
                  }
                }), (function (error) {
                  if (!append) {
                    Curry._1(setData, (function (param) {
                            return {
                                    TAG: /* Error */2,
                                    _0: error
                                  };
                          }));
                  }
                  return Curry._1(setIsLoadingMore, (function (param) {
                                return false;
                              }));
                }));
  };
  React.useEffect((function () {
          fetchOrdersForTab(/* InProgress */0, "PENDING", setPendingOrders, undefined, undefined, undefined, undefined);
          fetchOrdersForTab(/* Completed */1, "CONFIRMED", setCompletedOrders, undefined, undefined, undefined, undefined);
          
        }), []);
  var match$10 = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var setOrderProducts = match$10[1];
  var orderProducts = match$10[0];
  var refetchOrders = function (status) {
    var tab = status === "PENDING" ? /* InProgress */0 : /* Completed */1;
    var setData = tab ? setCompletedOrders : setPendingOrders;
    var pag = tab ? completedPagination : pendingPagination;
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._4(OrderRepoInstance.fetchOrders, status, 0, 20, searchMobile);
                }), (function (data) {
                  Curry._1(setData, (function (param) {
                          return {
                                  TAG: /* Live */1,
                                  _0: data
                                };
                        }));
                  pag.current = {
                    offset: 0,
                    scrollCount: 0,
                    hasMore: data.length >= 20
                  };
                  
                }), (function (param) {
                  
                }));
  };
  var geoRegionsList;
  switch (geoRegions.TAG | 0) {
    case /* Live */1 :
        geoRegionsList = geoRegions._0;
        break;
    case /* Loading */0 :
    case /* Error */2 :
        geoRegionsList = /* [] */0;
        break;
    
  }
  var allOrders;
  switch (orders.TAG | 0) {
    case /* Live */1 :
        allOrders = Belt_Array.map(orders._0, (function (param) {
                return PorterStoreTypes.mapApiOrderToStoreOrder(geoRegionsList, param);
              }));
        break;
    case /* Loading */0 :
    case /* Error */2 :
        allOrders = [];
        break;
    
  }
  var pendingCount;
  switch (pendingOrders.TAG | 0) {
    case /* Live */1 :
        pendingCount = pendingOrders._0.length;
        break;
    case /* Loading */0 :
    case /* Error */2 :
        pendingCount = 0;
        break;
    
  }
  var completedCount;
  switch (completedOrders.TAG | 0) {
    case /* Live */1 :
        completedCount = completedOrders._0.length;
        break;
    case /* Loading */0 :
    case /* Error */2 :
        completedCount = 0;
        break;
    
  }
  var isLoading;
  switch (orders.TAG | 0) {
    case /* Loading */0 :
        isLoading = true;
        break;
    case /* Live */1 :
    case /* Error */2 :
        isLoading = false;
        break;
    
  }
  var currentStatus = activeTab ? "CONFIRMED" : "PENDING";
  var loadMoreRef = React.useRef(function (param) {
        
      });
  React.useEffect(function () {
        loadMoreRef.current = (function (param) {
            var pag = activeTab ? completedPagination : pendingPagination;
            var p = pag.current;
            if (!(p.hasMore && !isLoadingMore && !isLoading && p.scrollCount < 20)) {
              return ;
            }
            var nextOffset = p.offset + 20 | 0;
            pag.current = {
              offset: nextOffset,
              scrollCount: p.scrollCount + 1 | 0,
              hasMore: p.hasMore
            };
            return fetchOrdersForTab(activeTab, currentStatus, setOrders, nextOffset, true, searchMobile, undefined);
          });
        
      });
  var handleTableScroll = function ($$event) {
    var target = $$event.target;
    var scrollHeight = target.scrollHeight;
    var scrollTop = target.scrollTop;
    var clientHeight = target.clientHeight;
    if (((scrollHeight - scrollTop | 0) - clientHeight | 0) < 200) {
      return Curry._1(loadMoreRef.current, undefined);
    }
    
  };
  var handleTabChange = function (tab) {
    Curry._1(setActiveTab, (function (param) {
            return tab;
          }));
    return Curry._1(setSearchMobile, (function (param) {
                  return "";
                }));
  };
  var handleSearch = function (mobile) {
    Curry._1(setSearchMobile, (function (param) {
            return mobile;
          }));
    return fetchOrdersForTab(activeTab, currentStatus, setOrders, undefined, undefined, mobile, undefined);
  };
  var handleClearSearch = function (param) {
    Curry._1(setSearchMobile, (function (param) {
            return "";
          }));
    return fetchOrdersForTab(activeTab, currentStatus, setOrders, undefined, undefined, "", undefined);
  };
  var tmp;
  if (match$2[0] !== undefined) {
    var handleClose = function (param) {
      Curry._1(setSelectedOrder, (function (param) {
              
            }));
      Curry._1(setOrderDetail, (function (param) {
              return {
                      TAG: /* Loading */0,
                      _0: undefined
                    };
            }));
      return Curry._1(setOrderProducts, (function (param) {
                    return {
                            TAG: /* Loading */0,
                            _0: undefined
                          };
                  }));
    };
    var tmp$1;
    switch (orderDetail.TAG | 0) {
      case /* Loading */0 :
          tmp$1 = React.createElement("div", {
                className: "ps-sidebar__header"
              }, React.createElement("span", {
                    className: "ps-sidebar__order-id"
                  }, PorterStoreStrings.loadingOrderDetails), React.createElement("button", {
                    className: "ps-sidebar__close",
                    onClick: (function (param) {
                        return handleClose(undefined);
                      })
                  }, React.createElement(PorterStoreIcons.Close.make, {})));
          break;
      case /* Live */1 :
          var detail = orderDetail._0;
          var allProductItems;
          switch (orderProducts.TAG | 0) {
            case /* Live */1 :
                allProductItems = PorterStoreTypes.mapOrderProductsToStoreItems(orderProducts._0);
                break;
            case /* Loading */0 :
            case /* Error */2 :
                allProductItems = [];
                break;
            
          }
          var mappedDetail = PorterStoreTypes.mapApiOrderDetailToOrderDetail(geoRegionsList, detail);
          var enrichedItems = Belt_Array.map(mappedDetail.items, (function (orderItem) {
                  var matchedProduct = Belt_Array.getBy(allProductItems, (function (p) {
                          return p.productCode === orderItem.productCode;
                        }));
                  if (matchedProduct !== undefined) {
                    return {
                            id: orderItem.id,
                            productCode: orderItem.productCode,
                            sku: orderItem.sku,
                            name: matchedProduct.name,
                            price: orderItem.price,
                            size: orderItem.size,
                            availableSizes: matchedProduct.availableSizes.length !== 0 ? matchedProduct.availableSizes : orderItem.availableSizes,
                            variants: matchedProduct.variants.length !== 0 ? matchedProduct.variants : orderItem.variants,
                            imageUrl: matchedProduct.imageUrl !== "" ? matchedProduct.imageUrl : orderItem.imageUrl,
                            hasValidation: matchedProduct.hasValidation
                          };
                  } else {
                    return orderItem;
                  }
                }));
          var enrichedDetail_order = mappedDetail.order;
          var enrichedDetail_partnerId = mappedDetail.partnerId;
          var enrichedDetail_addressLine1 = mappedDetail.addressLine1;
          var enrichedDetail_addressLine2 = mappedDetail.addressLine2;
          var enrichedDetail_state = mappedDetail.state;
          var enrichedDetail_pincode = mappedDetail.pincode;
          var enrichedDetail_lastUpdatedBy = mappedDetail.lastUpdatedBy;
          var enrichedDetail_lastUpdatedAt = mappedDetail.lastUpdatedAt;
          var enrichedDetail = {
            order: enrichedDetail_order,
            partnerId: enrichedDetail_partnerId,
            addressLine1: enrichedDetail_addressLine1,
            addressLine2: enrichedDetail_addressLine2,
            state: enrichedDetail_state,
            pincode: enrichedDetail_pincode,
            items: enrichedItems,
            lastUpdatedBy: enrichedDetail_lastUpdatedBy,
            lastUpdatedAt: enrichedDetail_lastUpdatedAt
          };
          tmp$1 = React.createElement(PorterStoreOrderSidebar.make, {
                orderDetail: enrichedDetail,
                onClose: handleClose,
                isCompleted: activeTab === /* Completed */1,
                allProducts: allProductItems,
                onSave: (function (payload, onSuccess, onFailure) {
                    var orderId = detail.order_uuid;
                    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                                  return Curry._2(OrderRepoInstance.updateOrder, orderId, payload);
                                }), (function (data) {
                                  Curry._1(setOrderDetail, (function (param) {
                                          return {
                                                  TAG: /* Live */1,
                                                  _0: data
                                                };
                                        }));
                                  refetchOrders(currentStatus);
                                  return Curry._1(onSuccess, undefined);
                                }), (function (_error) {
                                  return Curry._1(onFailure, undefined);
                                }));
                  }),
                onSendPaymentLink: (function (param, param$1, onFailure) {
                    var driverId = Belt_Option.flatMap(detail.requester, (function (r) {
                            return r.user_id;
                          }));
                    var orderUuid = detail.order_uuid;
                    var onSuccess = function (param) {
                      handleClose(undefined);
                      refetchOrders("PENDING");
                      refetchOrders("CONFIRMED");
                      return Curry._1(showSuccess, PorterStoreStrings.toastPaymentSuccess);
                    };
                    if (driverId !== undefined) {
                      return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                                    return Curry._1(OrderRepoInstance.getWalletState, driverId);
                                  }), (function (walletState) {
                                    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                                                  return Curry._2(OrderRepoInstance.payOrderWithWallet, orderUuid, walletState.wallet_version_id);
                                                }), (function (param) {
                                                  return Curry._1(onSuccess, undefined);
                                                }), (function (_error) {
                                                  return Curry._1(onFailure, undefined);
                                                }));
                                  }), (function (_error) {
                                    return Curry._1(onFailure, undefined);
                                  }));
                    } else {
                      return Curry._1(onFailure, undefined);
                    }
                  }),
                key: detail.order_uuid
              });
          break;
      case /* Error */2 :
          tmp$1 = React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: "ps-sidebar__header"
                  }, React.createElement("button", {
                        className: "ps-sidebar__close",
                        onClick: (function (param) {
                            return handleClose(undefined);
                          })
                      }, React.createElement(PorterStoreIcons.Close.make, {}))), React.createElement(PorterStoreToast.make, {
                    toastType: /* Failure */1,
                    message: PorterStoreStrings.toastOrderDetailFailure,
                    visible: true
                  }));
          break;
      
    }
    tmp = React.createElement("div", {
          className: "ps-sidebar-overlay",
          onClick: (function (param) {
              return handleClose(undefined);
            })
        }, React.createElement("div", {
              className: "ps-sidebar",
              onClick: (function ($$event) {
                  $$event.stopPropagation();
                  
                })
            }, tmp$1));
  } else {
    tmp = null;
  }
  return React.createElement(Column$Catalyst.make, {
              children: null,
              className: ""
            }, React.createElement("div", {
                  className: "ps-page"
                }, React.createElement(PorterStoreOrdersTable.make, {
                      allOrders: allOrders,
                      pendingCount: pendingCount,
                      completedCount: completedCount,
                      isLoading: isLoading,
                      isLoadingMore: isLoadingMore,
                      activeTab: activeTab,
                      onTabChange: handleTabChange,
                      onOrderClick: (function (order) {
                          Curry._1(setSelectedOrder, (function (param) {
                                  return order;
                                }));
                          var orderId = order.orderId;
                          Curry._1(setOrderDetail, (function (param) {
                                  return {
                                          TAG: /* Loading */0,
                                          _0: undefined
                                        };
                                }));
                          Curry._1(setOrderProducts, (function (param) {
                                  return {
                                          TAG: /* Loading */0,
                                          _0: undefined
                                        };
                                }));
                          ApiUtils$Catalyst.handleAPIRequest((function (param) {
                                  return Curry._1(OrderRepoInstance.fetchOrderDetail, orderId);
                                }), (function (data) {
                                  return Curry._1(setOrderDetail, (function (param) {
                                                return {
                                                        TAG: /* Live */1,
                                                        _0: data
                                                      };
                                              }));
                                }), (function (error) {
                                  return Curry._1(setOrderDetail, (function (param) {
                                                return {
                                                        TAG: /* Error */2,
                                                        _0: error
                                                      };
                                              }));
                                }));
                          return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                                        return Curry._1(OrderRepoInstance.fetchOrderProducts, orderId);
                                      }), (function (data) {
                                        return Curry._1(setOrderProducts, (function (param) {
                                                      return {
                                                              TAG: /* Live */1,
                                                              _0: data
                                                            };
                                                    }));
                                      }), (function (error) {
                                        return Curry._1(setOrderProducts, (function (param) {
                                                      return {
                                                              TAG: /* Error */2,
                                                              _0: error
                                                            };
                                                    }));
                                      }));
                        }),
                      onScroll: handleTableScroll,
                      onSearch: handleSearch,
                      onClearSearch: handleClearSearch
                    })), tmp, React.createElement(PorterStoreToast.make, {
                  toastType: toastState.toastType,
                  message: toastState.message,
                  visible: toastState.visible
                }));
}

var make = PorterStoreComponent;

export {
  make ,
  
}
/* react Not a pure module */
